module.exports = __webpack_public_path__ + "img/4B站.2cfda4f0.svg";